import Reveal from "./Reveal";
import { VIDEO_URL, IMAGES } from "../constants";
import { Wand2, Mic } from "lucide-react";

const SONGS = ["Defying Gravity", "The Wizard and I", "Sustained High-Intensity Belt"];

export default function Wicked() {
  return (
    <section id="theatre" className="relative py-24 lg:py-32 overflow-hidden" data-testid="wicked-section">
      <div className="pointer-events-none absolute top-0 left-0 w-[480px] h-[480px] rounded-full bg-hblue/10 blur-[140px]" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <Reveal>
          <div className="relative rounded-3xl overflow-hidden border border-white/10 aspect-[4/5] max-h-[560px]">
            <img
              src={IMAGES.stageWarm}
              alt="Hulda Perez on stage in golden light"
              loading="lazy"
              className="duotone absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-hpink/35 via-transparent to-hblue/25 mix-blend-overlay" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 font-mono text-[10px] tracking-[0.3em] text-white/80 uppercase">
              Fairy Godmother - Under the Gold Light
            </div>          </div>
        </Reveal>

        <div>
          <Reveal>
            <div className="flex items-center gap-3 mb-5">
              <span className="font-mono text-xs tracking-[0.3em] text-hpink">03</span>
              <span className="h-px w-12 bg-gradient-to-r from-hpink to-horange" />
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-hdim">Theatre &amp; Stage</span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight leading-[0.92]">
              Wicked
            </h2>
            <p className="mt-4 font-mono text-xs sm:text-sm tracking-[0.2em] text-horange uppercase">
              Elphaba (Lead) — Musical Theatre Showcase
            </p>
            <p className="mt-6 text-hmut text-base sm:text-lg leading-relaxed max-w-xl">
              Performed lead dramatic and contemporary musical theatre repertoire featuring sustained
              high-intensity vocal belting.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              {SONGS.map((s) => (
                <span
                  key={s}
                  className="inline-flex items-center rounded-full border border-hpink/35 bg-hpink/10 px-4 py-2 text-xs font-semibold text-white"
                  data-testid="wicked-song-chip"
                >
                  {s}
                </span>
              ))}
            </div>
            <a
              href={VIDEO_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="wicked-video-link"
              className="mt-8 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-hblue hover:text-white transition-colors"
            >
              Hear the belt in the reel →
            </a>
          </Reveal>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16 mt-14 grid md:grid-cols-2 gap-6">
        <Reveal delay={0.05}>
          <div
            className="group h-full rounded-3xl border border-white/10 bg-white/[0.04] p-8 lg:p-10 transition-all duration-300 hover:border-horange/40"
            data-testid="theatre-card-into-the-woods"
          >
            <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-horange/20 to-hblue/20 border border-horange/30 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
              <Mic size={20} className="text-horange" />
            </div>
            <div className="flex items-start justify-between gap-4">
              <h3 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight">Into The Woods</h3>
              <span className="shrink-0 font-mono text-[9px] tracking-[0.25em] text-hblue border border-hblue/40 rounded-full px-3 py-1">
                VOICEOVER
              </span>
            </div>
            <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.25em] text-horange">
              Role: The Giant
            </p>
            <p className="mt-4 text-hmut leading-relaxed text-sm sm:text-base">
              Brought the Giant to life through voiceover performance work.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div
            className="group h-full rounded-3xl border border-white/10 bg-white/[0.04] p-8 lg:p-10 transition-all duration-300 hover:border-hpink/40"
            data-testid="theatre-card-cinderella"
          >
            <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-hpink/20 to-horange/20 border border-hpink/30 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
              <Wand2 size={20} className="text-hpink" />
            </div>
            <div className="flex items-start justify-between gap-4">
              <h3 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight">Cinderella</h3>
              <span className="shrink-0 font-mono text-[9px] tracking-[0.25em] text-hpink border border-hpink/40 rounded-full px-3 py-1">
                STAGE ROLE
              </span>
            </div>
            <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.25em] text-horange">
              Role: Fairy Godmother
            </p>
            <p className="mt-4 text-hmut leading-relaxed text-sm sm:text-base">
              Cast as the Fairy Godmother.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
